module.exports = __webpack_public_path__ + "img/Weapon_110.d4468c80.png";